'use strict';

// some convenient animation helpers for query
(function ($) {
    $.extend($.fn, {
        // fade an element out, execute given function, then fade back in
        // func will be added to queue and must contain a dequeue call; it will be passed the element being faded out/in
        // outSpeed and inSpeed optionally control speed of fading; they default to 'fast' and 'slow' respectively
        doDuringFade: function doDuringFade(func, outSpeed, inSpeed) {
            $(this).stop(true, true).fadeOut(outSpeed || 'fast').queue(function () {
                func(this);
            }).fadeIn(inSpeed || 'slow');
        },

        changeTextDuringFade: function changeTextDuringFade(newText) {
            /// <summary>
            /// if newText is same as element's current text, do nothing.
            /// otherwise fade out, change text to newText and fade back in
            /// </summary>
            /// <param name="newText" type="string">new text for the element</param>

            $(this).each(function () {
                var $el = $(this);
                var fadetext = $el.data('fadetext');

                // do nothing if the text is already changing to that, or is equal to taht
                if (newText === fadetext || newText === $el.text() && !fadetext) return;

                $el.data('fadetext', newText).doDuringFade(function (elt) {
                    $(elt).text($(elt).data('fadetext')).removeData('fadetext').dequeue();
                });
            });
        },

        equalHeights: function equalHeights() {
            var maxHeight = 0,
                $this = $(this);

            $this.each(function () {
                var height = $(this).innerHeight();

                if (height > maxHeight) {
                    maxHeight = height;
                }
            });

            return $this.height(maxHeight);
        }
    });
})(jQuery);

//--------------------------------------------------------------------------------------------
// ondelayed keyup - jquery plugin - based on http://stackoverflow.com/a/6054104
(function ($) {
    $.extend($.fn, {
        onDelayedKeyup: function onDelayedKeyup(handler, delay) {
            var self = this;
            var timerKey = plupload.guid();
            $(this).keyup(function (e) {
                if (typeof window[timerKey] != 'undefined') {
                    window.clearTimeout(window[timerKey]);
                }
                window[timerKey] = window.setTimeout(function () {
                    handler.call(self.element, e);
                }, delay || 500);
            });
        }
    });
})(jQuery);

// Replacement for toggle(handler, handler) that was removed in jquery 1.9+
// @see http://stackoverflow.com/questions/14301935/where-has-fn-toggle-handlereventobject-handlereventobject-gone
(function ($) {
    $.extend($.fn, {
        toggleClick: function toggleClick() {
            var functions = arguments,
                iteration = 0;
            return this.click(function () {
                functions[iteration].call();
                iteration = (iteration + 1) % functions.length;
            });
        }
    });
})(jQuery);

// Test if element is in viewport(visible on screen)
// @see http://upshots.org/javascript/jquery-test-if-element-is-in-viewport-visible-on-screen
(function ($) {
    $.extend($.fn, {
        isOnScreen: function isOnScreen() {
            var win = $(window);

            var viewport = {
                top: win.scrollTop(),
                left: win.scrollLeft()
            };
            viewport.right = viewport.left + win.width();
            viewport.bottom = viewport.top + win.height();

            var bounds = this.offset();
            bounds.right = bounds.left + this.outerWidth();
            bounds.bottom = bounds.top + this.outerHeight();

            return !(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom);
        }
    });
})(jQuery);